import {BaseWorkTaskTypeEnum, BookingState, GetWorkPlan6BookingDTO, WorkTaskStatus} from "../../../../../api/api";
import Button from '../../../../../components/button/Button';
import {PlayIconOutline} from "../../../../../assets/icons/PlayIconOutline";
import {StopIcon} from "../../../../../assets/icons/StopIcon";
import {WorkPlanItemDTOExtended} from "../../../../../models/WorkPlanItem";

interface Props {
    task: WorkPlanItemDTOExtended;
    taskStatus: WorkTaskStatus;
    booking: GetWorkPlan6BookingDTO;
    isCalendar?: boolean;
    handleUpdateStatus: (e?: any) => Promise<void>;
    updatingStatus: boolean,
}

export const WorkTaskActionButton = (props: Props) => {
    const {booking, task, isCalendar, taskStatus, handleUpdateStatus, updatingStatus} = props;
    
    const isBookingActive = booking.state === BookingState.OnGoing || booking.state === BookingState.OnRoute;
    switch (taskStatus) {
        case WorkTaskStatus.Planned:
        case WorkTaskStatus.PlannedAppointment:
            // When task is planned (Only allow start when booking is ongoing)
            return <Button
                    variant="primary"
                    onClick={(e) => handleUpdateStatus(e)}
                    disabled={ isCalendar || !isBookingActive }
                    data-testid="workplan-overview-buttons"
                    isLoading={updatingStatus}>
                        <PlayIconOutline size="28px" />
                        Start opgave
                </Button>;
        case WorkTaskStatus.Ongoing:
            // We want to support a case where the user can 'join' a task if booking is already booking.state == OnGoing
            
            if(booking.state === BookingState.OnRoute || booking.state === BookingState.Planned) {
                return <Button
                    variant="primary"
                    onClick={(e) => handleUpdateStatus(e)}
                    data-testid="workplan-overview-buttons"
                    disabled={ isCalendar || !isBookingActive }
                    isLoading={updatingStatus}>
                    <PlayIconOutline size="28px" />
                    Tilslut mig opgave
                </Button>
            }
            return <Button
                variant={task.isClosePrimary ? "primary" : "secondary"}
                onClick={(e) => handleUpdateStatus(e)}
                disabled={ isCalendar || !isBookingActive || (!task.isCloseAllowed && task.baseWorkTaskType !== BaseWorkTaskTypeEnum.InternalWorkTask)}
                data-testid="workplan-overview-buttons"
                isLoading={updatingStatus}>
                <StopIcon size="16px" />
                Stop opgave
            </Button>
        default:
            return <Button
                disabled={ true }
                data-testid="workplan-overview-buttons">
                    <PlayIconOutline size="28px" />
                    Start opgave
            </Button>;
    }
}